module.exports = __webpack_public_path__ + "img/slogan-one-spirit-coral.f9f97482.svg";